<template>
  <div>
    <div class="columns is-mobile is-gapless mb-0">
      <div :style="cuneistyle" class="column is-size-5">
        {{ value.orth.cuneiform }}
      </div>
      <div class="column">
        <div class="is-size-5">
          <trans-literal :word="value.orth.w" />
        </div>
      </div>
      <div class="column" style="color: black">
        <a class="is-size-5" :href="value.url" target="_blank">
          <b>{{ value.title }}</b>
        </a>
      </div>
      <div class="column" style="color: black">
        <a class="is-size-5" :href="value.url" target="_blank">
          {{ value.gw }}
        </a>
      </div>
      <div class="column" style="color: black">
        <div class="is-size-5">
          {{ value.pos }}
        </div>
      </div>
    </div>
    <div style="color: black">
      <div class="is-size-5">
        {{ value.meaning }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import TransLiteral from "./TransLiteral.vue";
export default Vue.extend({
  name: "HuburResult",
  props: {
    value: { required: true },
    cuneistyle: { required: true },
  },
  components: { TransLiteral },
});
</script>
